<template>
  <div
    class="order-item"
    @click="$emit('choose', order.orderNumber)"
  >
    <div class="number">
      {{ order.orderNumber }}
      <span>от {{ order.createdAt | fullDate }}</span>
    </div>

    <div class="status">
      <span>Статус</span>
      <div :class="{warning: status === 'Отменен'}">
        {{ status }}
      </div>
    </div>

    <div class="delivery">
      <span>Доставка</span>
      <div>
        {{ delivery }}
      </div>
    </div>

    <div class="payment">
      <span>Оплата</span>
      <div>
        {{ payment }}
      </div>
    </div>

    <div class="price price-rub">
      <span>Сумма</span>
      {{ order.subtotal | price }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'order-item',

  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    status() {
      switch (this.order.status) {
        case 'accepted':
          return 'В обработке';
        case 'performed':
          return 'Выполнен';
        case 'shipped_to_store':
          return 'Доставляется в магазин';
        case 'waited':
          return 'Ожидает в магазине';
        case 'shipped':
          return 'Доставляется';
        case 'prepared':
          return 'Собирается';
        case 'cancelled':
          return 'Отменён';
        default:
          return 'В обработке';
      }
    },

    payment() {
      switch(this.order.paymentMethod) {
        case 'card_online':
          return 'Онлайн оплата'
        case 'cash_or_card':
          return 'Наличными или картой при получении'
        default:
          return 'Наличными при получении'
      }
    },

    delivery() {
      switch(this.order.shippingGroupType) {
        case 'pickup':
        case 'thirdparty':
          return 'Самовывоз'
        default:
          return 'Курьерская служба'
      }
    },
  },
};
</script>

<style lang="scss">
.order-item {
  font-size: 14px;
  line-height: 24px;
  padding: 24px 12px 32px;
  border-bottom: 1px solid $gray_lu;

  & > div {
    display: flex;
    margin-top: 8px;
  }

  span {
    min-width: 65px;
    margin-right: 40px;
    color: $gray;
  }

  .number {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;

    span {
      margin-right: 0;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
    }
  }

  .status {
    margin-top: 12px;

    & > div {
      &.warning {
        color: $red;
      }
    }
  }

  .delivery > div,
  .payment > div {
    display: flex;
    flex-direction: column;

    span {
      margin-right: 0;

      &.warning {
        color: $red;
      }
    }
  }

  .price {
    font-size: 16px;
    font-weight: bold;

    span {
      font-size: 14px;
      font-weight: normal;
    }
  }
}

@include breakpoint("tablet") {
  .order-item {
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: 12px;

    & > div {
      width: 116px;
      margin-right: 24px;
    }

    .number {
      width: 144px;
    }

    .payment {
      margin-right: 0;
    }

    .status,
    .delivery,
    .payment,
    .price {
      margin-top: 0;

      & > span {
        display: none;
      }
    }

    .payment > div {
      overflow: hidden;

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .price {
      width: auto;
      min-width: 67px;
      margin-right: 0;
      justify-content: flex-end;
      margin-left: auto;
    }
  }
}

@include breakpoint("desktop") {
  .order-item {
    padding: 24px 20px;
    cursor: pointer;
    transition: .2s background-color ease;

    & > div {
      margin-right: 24px;
    }

    &:hover {
      background-color: $gray_bgr;
    }

    .number {
      width: 164px;
    }

    .status,
    .delivery {
      width: 140px;
    }

    .payment {
      width: 160px;
    }
  }
}
</style>